import { render, staticRenderFns } from "./InventoryList.vue?vue&type=template&id=9ce3d60e"
import script from "./InventoryList.vue?vue&type=script&lang=js"
export * from "./InventoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports